var React = require('react');

function HashnodeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#2962ff","d":"M42.164,17.126L30.874,5.835c-3.781-3.781-9.967-3.781-13.748,0L5.836,17.126\tc-3.781,3.781-3.781,9.967,0,13.748l11.291,11.291c3.781,3.781,9.967,3.781,13.748,0l11.291-11.291\tC45.945,27.093,45.945,20.907,42.164,17.126z M24,31c-3.866,0-7-3.134-7-7c0-3.866,3.134-7,7-7s7,3.134,7,7\tC31,27.866,27.866,31,24,31z"}));
}

HashnodeInline.defaultProps = {"x":"0px","y":"0px","width":"22","height":"22","viewBox":"0 0 48 48"};

module.exports = HashnodeInline;

HashnodeInline.default = HashnodeInline;
